import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { WorkspaceService } from '../services/workspace.service';
import { FORMS_CONFIG } from '../forms-config.token';
import { KnownHeaders } from '../config/known-headers';

export const workspaceHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const workspaceService = inject(WorkspaceService);
  const config = inject(FORMS_CONFIG);
  const workspace = workspaceService.activeWorkspace();

  if (workspace && req.url.startsWith(config.apiUrl)) {
    req = req.clone({
      setHeaders: { [KnownHeaders.WorkspaceId]: workspace.id },
    });
  }

  return next(req);
};
